import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createSchoolService,
  getSchoolByIdService,
  getSchoolsService,
  toggleSchoolActiveService,
  updateSchoolService,
} from "../../../services/schools/school.service";

export const getSchoolsThunk = createAsyncThunk(
  "schools/getAll",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getSchoolsService(page, search);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener escuelas";

      return rejectWithValue(message);
    }
  },
);

export const createSchoolThunk = createAsyncThunk(
  "schools/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createSchoolService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear escuela";

      return rejectWithValue(message);
    }
  },
);

export const getSchoolByIdThunk = createAsyncThunk(
  "schools/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getSchoolByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener escuela";

      return rejectWithValue(message);
    }
  },
);

export const updateSchoolThunk = createAsyncThunk(
  "schools/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateSchoolService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar escuela";

      return rejectWithValue(message);
    }
  },
);

export const toggleSchoolActiveThunk = createAsyncThunk(
  "schools/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleSchoolActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);
